/**
 * 全局常量定义
 */

// 日期时间格式
export const DATE_FORMAT_FULL_TIME = 'YYYY-MM-DD HH:mm:ss'
export const DATE_FORMAT = 'YYYY-MM-DD'
export const TIME_FORMAT = 'HH:mm:ss'
